import React, { memo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Termsofservice from '../../components/common/Termsofservice';
import PrivacyPolicy from '../../components/common/PrivacyPolicy'; // Create this component
import TranslateFile from '../../Loc/TranslateFile';

const Footer = () => {
    // State to control modal visibility for both modals
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const currentLang = TranslateFile();

    // Handlers for Terms of Service Modal
    const handleTermsModalOpen = () => setShowTermsModal(true);
    const handleTermsModalClose = () => setShowTermsModal(false);

    // Handlers for Privacy Policy Modal
    const handlePrivacyModalOpen = () => setShowPrivacyModal(true);
    const handlePrivacyModalClose = () => setShowPrivacyModal(false);

    return (
        <footer className="dashboard-footer">
            <div className="footer-right">
                <span className="mandatory-right">*</span>
                <span>
                    {currentLang?.Footer_des}
                    {" "}
                    <a href="#" onClick={(e) => { e.preventDefault(); handleTermsModalOpen(); }}>
                        {currentLang?.Terms_of_Service}
                    </a>{" "}
                    {currentLang?.And}{" "}
                    <a href="#" onClick={(e) => { e.preventDefault(); handlePrivacyModalOpen(); }}>
                        {currentLang?.Privacy_Policy}
                    </a>.
                </span>
            </div>

            {/* Terms of Service Modal */}
            <Modal show={showTermsModal} onHide={handleTermsModalClose} size="xl" centered>
                {/* <Modal.Header closeButton> */}
                <Modal.Header>
                    <Modal.Title> {currentLang?.Terms_of_Service}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Termsofservice /> {/* Terms of Service content */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="btn btn-danger mtt-4" onClick={handleTermsModalClose}>
                        {currentLang?.Buttons?.Close}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Privacy Policy Modal */}
            <Modal show={showPrivacyModal} onHide={handlePrivacyModalClose} size="xl" centered>
                <Modal.Header >
                    <Modal.Title>{currentLang?.Privacy_Policy}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PrivacyPolicy /> {/* Privacy Policy content */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="btn btn-danger mtt-4" onClick={handlePrivacyModalClose}>
                        {currentLang?.Buttons?.Close}
                    </Button>
                </Modal.Footer>
            </Modal>
        </footer>
    );
};

export default memo(Footer);
